import { render, staticRenderFns } from "./Month.vue?vue&type=template&id=bd58e5c0"
import script from "./Month.vue?vue&type=script&lang=js"
export * from "./Month.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports